import { createSelector } from '@reduxjs/toolkit'
import { RowDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'

export function summarizeImnooEstimates(
  rows: Array<
    Pick<
      RowDto,
      | 'id'
      | 'partTypeId'
      | 'isImnooEstimationPending'
      | 'hasFailedImnooEstimation'
      | 'canRetryImnooEstimation'
    >
  >,
) {
  const pending = new Set<string>()
  const failed = new Set<string>()
  const retryable = new Set<string>()
  for (const row of rows) {
    const id = row.partTypeId || row.id
    if (!id) continue
    if (row.isImnooEstimationPending) pending.add(id)
    if (row.hasFailedImnooEstimation) failed.add(id)
    if (row.canRetryImnooEstimation) retryable.add(id)
  }
  return {
    pending: pending.size,
    failed: failed.size,
    retryable: retryable.size,
    unresolved: new Set([...pending, ...failed]).size,
  }
}

export const imnooEstimationSummarySelector = createSelector(
  [
    (state: RootAppState) => state.project.partTypes,
    (state: RootAppState) => state.project.partInstances,
  ],
  (parts, instances) =>
    summarizeImnooEstimates([
      ...Object.values(parts || {}),
      ...Object.values(instances || {}),
    ]),
)
